import PlinkoGraphicBase from './Base'

class Plinko extends PlinkoGraphicBase {
  size: number

  constructor(Matter: any, x: number, y: number, size: number) {
    const options = {
      restitution: 1,
      friction: 0,
      isStatic: true,
    }

    const body = Matter.Bodies.circle(x, y, size, options)
    super(Matter, body)

    this.size = size
  }

  display(p5: any) {
    const position = this.body.position
    const angle = this.body.angle

    p5.push()
    p5.translate(position.x, position.y)

    p5.rotate(angle)
    p5.imageMode(p5.CENTER)
    p5.noStroke()
    p5.fill(245, 245, 245) // color
    p5.ellipseMode(p5.RADIUS)
    p5.ellipse(0, 0, this.size, this.size)
    p5.pop()
  }

  destroy() {
    this.body = null
  }
}
export default Plinko
